const AppConfig = Object.freeze({
    baseUrl: 'https://gojob-x5qp.onrender.com'
});

export default AppConfig;